import React from 'react';
import { Skeleton } from '@mui/material';

const ScoreClusterWaffleChartSkeleton: React.FC = () => {
  return <Skeleton variant="rectangular" width="100%" height="100%" style={{ minWidth: 300, minHeight: 300 }} />;
};

export default ScoreClusterWaffleChartSkeleton;
